import React, { createContext, useContext, useState } from "react";

const translations = {
  en: {
    "brand": "My Property",
    "tagline": "My Property My Life",
    "nav.home": "Home",
    "nav.browse": "Browse Properties",
    "nav.services": "Services",
    "nav.terms": "Terms",
    "nav.login": "Login",
    "nav.register": "Register",
    "nav.logout": "Logout",
    "nav.dashboard": "Dashboard",
    "nav.account": "Account",
    "nav.admin": "Admin",
    "hero.title": "Find your perfect place, wherever you like",
    "hero.sub": "Verified mediators, real listings for Sale, Rent & Lease across Tier-2 & Tier-3 cities. Trusted, local, and simple.",
    "hero.search": "Search by pin code, area or city",
    "hero.cta": "Explore Properties",
    "hero.near": "Properties Near Me",
    "featured": "Featured Properties",
    "featured.sub": "Handpicked homes, plots and commercial spaces",
    "services.title": "More services, coming soon",
    "services.sub": "My Property is growing into a complete life platform for Where You Like",
    "services.events": "Events",
    "services.catering": "Catering",
    "services.decorators": "Decorators",
    "services.soon": "Coming Soon",
    "filter.all": "All",
    "filter.sale": "For Sale",
    "filter.rent": "For Rent",
    "filter.lease": "For Lease",
    "filter.type": "Property Type",
    "filter.radius": "Within (km)",
    "filter.nearme": "Use My Location",
    "filter.search": "Search",
    "prop.sale": "For Sale",
    "prop.rent": "For Rent",
    "prop.lease": "For Lease",
    "prop.sold": "SOLD OUT",
    "prop.badge": "Mediator Badge",
    "prop.details": "Property Details",
    "prop.dimensions": "Dimensions",
    "prop.area": "Built-up Area",
    "prop.beds": "Bedrooms",
    "prop.baths": "Bathrooms",
    "prop.rera": "RERA License",
    "prop.location": "Location",
    "prop.nearby": "What's Nearby",
    "prop.documents": "Documents",
    "prop.enquire": "Send Enquiry",
    "prop.enquiryNote": "Your enquiry goes to our team first, then to the mediator.",
    "prop.distance": "away",
    "enquiry.sent": "Enquiry sent! Our team will review and connect you.",
    "enquiry.pending": "Enquiry pending admin approval",
    "enquiry.confirmed": "Booking confirmed! Complete payment below.",
    "enquiry.rejected": "This enquiry was not approved by our team.",
    "pay.title": "Complete Your Payment",
    "pay.upi": "UPI ID",
    "pay.scan": "Scan the QR code to pay",
    "auth.loginTitle": "Welcome back",
    "auth.registerTitle": "Create your account",
    "auth.name": "Full Name",
    "auth.email": "Email",
    "auth.password": "Password",
    "auth.phone": "Phone Number",
    "auth.role": "I am a",
    "auth.customer": "Customer",
    "auth.broker": "Mediator",
    "auth.owner": "Owner",
    "auth.loginBtn": "Login",
    "auth.registerBtn": "Create Account",
    "auth.noAccount": "Don't have an account?",
    "auth.haveAccount": "Already have an account?",
    "admin.login": "Admin Access",
    "broker.dashboard": "Mediator Dashboard",
    "broker.active": "Active Listings",
    "broker.sold": "Sold Out",
    "broker.enquiries": "My Enquiries",
    "broker.addProperty": "Add Property",
    "broker.edit": "Edit",
    "broker.delete": "Delete",
    "broker.markSold": "Mark as Sold",
    "broker.markActive": "Mark Active",
    "broker.noProps": "No properties yet. Add your first listing.",
    "form.newProperty": "Add New Property",
    "form.editProperty": "Edit Property",
    "form.title": "Property Title",
    "form.desc": "Description",
    "form.listingType": "Listing Type",
    "form.propType": "Property Type",
    "form.price": "Price (₹)",
    "form.priceUnit": "Price note (e.g. per month)",
    "form.pincode": "Pin Code",
    "form.areaName": "Area Name",
    "form.address": "Full Address",
    "form.city": "City",
    "form.fetchLoc": "Auto-fetch from Pin Code/Area",
    "form.useGps": "Use my current location",
    "form.beds": "Bedrooms",
    "form.baths": "Bathrooms",
    "form.sqft": "Area (sq ft)",
    "form.dimensions": "Dimensions (e.g. 40x60 ft)",
    "form.facing": "Property Facing",
    "form.facingPick": "Select facing",
    "form.rera": "RERA License (optional)",
    "form.photos": "Property Photos",
    "form.gallery": "Choose from Gallery",
    "form.camera": "Take Photo",
    "form.docs": "Upload Documents (optional)",
    "form.save": "Save Property",
    "form.cancel": "Cancel",
    "form.uploading": "Uploading...",
    "admin.dashboard": "Admin Dashboard",
    "admin.overview": "Overview",
    "admin.brokers": "Mediators",
    "admin.customers": "Customers",
    "admin.listings": "Listings",
    "admin.enquiries": "Enquiries",
    "admin.chats": "Support Chats",
    "admin.settings": "Settings",
    "admin.assignBadge": "Assign Badge",
    "admin.block": "Block",
    "admin.unblock": "Unblock",
    "admin.approve": "Approve & Forward",
    "admin.confirm": "Confirm Booking",
    "admin.reject": "Reject",
    "admin.upiId": "UPI ID",
    "admin.upiName": "Payee Name",
    "admin.upiQr": "UPI QR Code",
    "admin.saveSettings": "Save Settings",
    "chat.title": "Chat with Support",
    "chat.placeholder": "Type your query...",
    "chat.send": "Send",
    "chat.empty": "Ask us anything about a property or your account.",
    "offers.title": "Offers & Coupons",
    "offers.forYou": "Special offers for you",
    "offers.validate": "Validate Coupon",
    "offers.validated": "Coupon Validated!",
    "offers.code": "Coupon Code",
    "offers.close": "Close",
    "offers.none": "No active offers right now.",
    "offers.create": "Create Offer",
    "offers.myOffers": "My Offers",
    "offers.push": "Push to Customers",
    "offers.reject": "Reject",
    "offers.discount": "Discount",
    "offers.couponCode": "Coupon Code",
    "offers.pendingPush": "Pending admin push",
    "offers.pushed": "Live to customers",
    "offers.rejected": "Rejected",
    "offers.loginToValidate": "Log in as a customer to validate this coupon",
    "offers.tab": "Offers",
    "offers.newTitle": "Offer Title",
    "offers.area": "Target Area (optional)",
    "dim.title": "Detailed Dimensions",
    "dim.label": "Label (e.g. Hall, Bedroom, Plot)",
    "dim.value": "Value",
    "dim.unit": "Unit",
    "dim.add": "Add Dimension",
    "dim.hint": "Add lengths/areas like Hall, Bedroom, East-West, North-South with any unit.",
    "role.loginAs": "Login as",
    "role.registerAs": "Register as",
    "track.brokerUpdated": "Updated by mediator",
    "track.adminUpdated": "Updated by admin",
    "track.pendingApproval": "Pending admin approval",
    "track.needsApproval": "Admin-managed · edits need approval",
    "enq.interest": "I want to",
    "enq.buy": "Buy",
    "enq.rent": "Rent",
    "enq.lease": "Lease",
    "enq.sell": "Sell",
    "enq.assign": "Assign to Mediator",
    "enq.assigned": "Assigned to",
    "enq.due": "Response due by",
    "enq.respond": "Submit Response",
    "enq.response": "Mediator's Response",
    "enq.responseDate": "Availability / Response Date",
    "enq.alert": "Mediator has responded — see details below.",
    "admin.requests": "Change Requests",
    "loading": "Loading...",
    "noResults": "No properties found. Try adjusting your filters.",
    "viewDetails": "View Details",
  },
  te: {
    "brand": "మై ప్రాపర్టీ",
    "tagline": "మై ప్రాపర్టీ మై లైఫ్",
    "nav.home": "హోమ్",
    "nav.browse": "ప్రాపర్టీలు చూడండి",
    "nav.services": "సేవలు",
    "nav.terms": "నిబంధనలు",
    "nav.login": "లాగిన్",
    "nav.register": "నమోదు",
    "nav.logout": "లాగ్అవుట్",
    "nav.dashboard": "డాష్‌బోర్డ్",
    "nav.account": "ఖాతా",
    "nav.admin": "అడ్మిన్",
    "hero.title": "మీకు నచ్చిన చోట మీ కల ఇల్లు కనుగొనండి",
    "hero.sub": "టైర్-2, టైర్-3 నగరాల్లో అమ్మకం, అద్దె, లీజు కోసం నమ్మకమైన మధ్యవర్తులు, నిజమైన లిస్టింగులు.",
    "hero.search": "పిన్ కోడ్, ఏరియా లేదా నగరం ద్వారా వెతకండి",
    "hero.cta": "ప్రాపర్టీలను చూడండి",
    "hero.near": "నా దగ్గర ప్రాపర్టీలు",
    "featured": "ఫీచర్డ్ ప్రాపర్టీలు",
    "featured.sub": "ఎంపిక చేసిన ఇళ్లు, ప్లాట్లు, వాణిజ్య స్థలాలు",
    "services.title": "మరిన్ని సేవలు త్వరలో",
    "services.sub": "మై ప్రాపర్టీ మీకు నచ్చిన చోట కోసం సంపూర్ణ లైఫ్ ప్లాట్‌ఫారంగా మారుతోంది",
    "services.events": "ఈవెంట్స్",
    "services.catering": "క్యాటరింగ్",
    "services.decorators": "డెకరేటర్స్",
    "services.soon": "త్వరలో",
    "filter.all": "అన్నీ",
    "filter.sale": "అమ్మకం",
    "filter.rent": "అద్దె",
    "filter.lease": "లీజు",
    "filter.type": "ప్రాపర్టీ రకం",
    "filter.radius": "పరిధి (కి.మీ)",
    "filter.nearme": "నా లొకేషన్ వాడండి",
    "filter.search": "వెతకండి",
    "prop.sale": "అమ్మకానికి",
    "prop.rent": "అద్దెకు",
    "prop.lease": "లీజుకు",
    "prop.sold": "అమ్ముడైంది",
    "prop.badge": "మధ్యవర్తి బ్యాడ్జ్",
    "prop.details": "ప్రాపర్టీ వివరాలు",
    "prop.dimensions": "కొలతలు",
    "prop.area": "నిర్మిత విస్తీర్ణం",
    "prop.beds": "బెడ్‌రూమ్‌లు",
    "prop.baths": "బాత్‌రూమ్‌లు",
    "prop.rera": "రెరా లైసెన్స్",
    "prop.location": "లొకేషన్",
    "prop.nearby": "సమీపంలో ఏమి ఉంది",
    "prop.documents": "డాక్యుమెంట్లు",
    "prop.enquire": "విచారణ పంపండి",
    "prop.enquiryNote": "మీ విచారణ ముందుగా మా టీంకి, తర్వాత మధ్యవర్తికి వెళుతుంది.",
    "prop.distance": "దూరం",
    "enquiry.sent": "విచారణ పంపబడింది! మా టీం సమీక్షించి మిమ్మల్ని కలుపుతుంది.",
    "enquiry.pending": "అడ్మిన్ ఆమోదం కోసం వేచి ఉంది",
    "enquiry.confirmed": "బుకింగ్ నిర్ధారించబడింది! కింద చెల్లింపు పూర్తి చేయండి.",
    "enquiry.rejected": "ఈ విచారణ మా టీం ద్వారా ఆమోదించబడలేదు.",
    "pay.title": "చెల్లింపు పూర్తి చేయండి",
    "pay.upi": "యూపీఐ ఐడీ",
    "pay.scan": "చెల్లించడానికి QR కోడ్ స్కాన్ చేయండి",
    "auth.loginTitle": "తిరిగి స్వాగతం",
    "auth.registerTitle": "మీ ఖాతా సృష్టించండి",
    "auth.name": "పూర్తి పేరు",
    "auth.email": "ఇమెయిల్",
    "auth.password": "పాస్‌వర్డ్",
    "auth.phone": "ఫోన్ నంబర్",
    "auth.role": "నేను",
    "auth.customer": "కస్టమర్",
    "auth.broker": "మధ్యవర్తి",
    "auth.owner": "యజమాని",
    "auth.loginBtn": "లాగిన్",
    "auth.registerBtn": "ఖాతా సృష్టించండి",
    "auth.noAccount": "ఖాతా లేదా?",
    "auth.haveAccount": "ఇప్పటికే ఖాతా ఉందా?",
    "admin.login": "అడ్మిన్ యాక్సెస్",
    "broker.dashboard": "మధ్యవర్తి డాష్‌బోర్డ్",
    "broker.active": "యాక్టివ్ లిస్టింగులు",
    "broker.sold": "అమ్ముడైనవి",
    "broker.enquiries": "నా విచారణలు",
    "broker.addProperty": "ప్రాపర్టీ జోడించండి",
    "broker.edit": "ఎడిట్",
    "broker.delete": "తొలగించు",
    "broker.markSold": "అమ్ముడైనట్లు గుర్తించు",
    "broker.markActive": "యాక్టివ్‌గా గుర్తించు",
    "broker.noProps": "ఇంకా ప్రాపర్టీలు లేవు. మొదటి లిస్టింగ్ జోడించండి.",
    "form.newProperty": "కొత్త ప్రాపర్టీ జోడించండి",
    "form.editProperty": "ప్రాపర్టీ ఎడిట్ చేయండి",
    "form.title": "ప్రాపర్టీ శీర్షిక",
    "form.desc": "వివరణ",
    "form.listingType": "లిస్టింగ్ రకం",
    "form.propType": "ప్రాపర్టీ రకం",
    "form.price": "ధర (₹)",
    "form.priceUnit": "ధర గమనిక (ఉదా. నెలకు)",
    "form.pincode": "పిన్ కోడ్",
    "form.areaName": "ఏరియా పేరు",
    "form.address": "పూర్తి చిరునామా",
    "form.city": "నగరం",
    "form.fetchLoc": "పిన్‌కోడ్/ఏరియా నుండి తీసుకోండి",
    "form.useGps": "నా ప్రస్తుత లొకేషన్ వాడండి",
    "form.beds": "బెడ్‌రూమ్‌లు",
    "form.baths": "బాత్‌రూమ్‌లు",
    "form.sqft": "విస్తీర్ణం (చ.అ)",
    "form.dimensions": "కొలతలు (ఉదా. 40x60 అడుగులు)",
    "form.facing": "ప్రాపర్టీ దిశ",
    "form.facingPick": "దిశ ఎంచుకోండి",
    "form.rera": "రెరా లైసెన్స్ (ఐచ్ఛికం)",
    "form.photos": "ప్రాపర్టీ ఫోటోలు",
    "form.gallery": "గ్యాలరీ నుండి ఎంచుకోండి",
    "form.camera": "ఫోటో తీయండి",
    "form.docs": "డాక్యుమెంట్లు అప్‌లోడ్ (ఐచ్ఛికం)",
    "form.save": "ప్రాపర్టీ సేవ్ చేయండి",
    "form.cancel": "రద్దు",
    "form.uploading": "అప్‌లోడ్ అవుతోంది...",
    "admin.dashboard": "అడ్మిన్ డాష్‌బోర్డ్",
    "admin.overview": "సమగ్ర వివరణ",
    "admin.brokers": "మధ్యవర్తులు",
    "admin.customers": "కస్టమర్లు",
    "admin.listings": "లిస్టింగులు",
    "admin.enquiries": "విచారణలు",
    "admin.chats": "సపోర్ట్ చాట్లు",
    "admin.settings": "సెట్టింగులు",
    "admin.assignBadge": "బ్యాడ్జ్ కేటాయించండి",
    "admin.block": "బ్లాక్",
    "admin.unblock": "అన్‌బ్లాక్",
    "admin.approve": "ఆమోదించి పంపండి",
    "admin.confirm": "బుకింగ్ నిర్ధారించండి",
    "admin.reject": "తిరస్కరించండి",
    "admin.upiId": "యూపీఐ ఐడీ",
    "admin.upiName": "చెల్లింపుదారు పేరు",
    "admin.upiQr": "యూపీఐ QR కోడ్",
    "admin.saveSettings": "సెట్టింగులు సేవ్ చేయండి",
    "chat.title": "సపోర్ట్‌తో చాట్",
    "chat.placeholder": "మీ ప్రశ్న టైప్ చేయండి...",
    "chat.send": "పంపండి",
    "chat.empty": "ప్రాపర్టీ లేదా ఖాతా గురించి ఏదైనా అడగండి.",
    "offers.title": "ఆఫర్లు & కూపన్లు",
    "offers.forYou": "మీ కోసం ప్రత్యేక ఆఫర్లు",
    "offers.validate": "కూపన్ ధృవీకరించండి",
    "offers.validated": "కూపన్ ధృవీకరించబడింది!",
    "offers.code": "కూపన్ కోడ్",
    "offers.close": "మూసివేయి",
    "offers.none": "ప్రస్తుతం యాక్టివ్ ఆఫర్లు లేవు.",
    "offers.create": "ఆఫర్ సృష్టించండి",
    "offers.myOffers": "నా ఆఫర్లు",
    "offers.push": "కస్టమర్లకు పంపండి",
    "offers.reject": "తిరస్కరించండి",
    "offers.discount": "డిస్కౌంట్",
    "offers.couponCode": "కూపన్ కోడ్",
    "offers.pendingPush": "అడ్మిన్ పుష్ కోసం వేచి ఉంది",
    "offers.pushed": "కస్టమర్లకు లైవ్",
    "offers.rejected": "తిరస్కరించబడింది",
    "offers.loginToValidate": "ఈ కూపన్ ధృవీకరించడానికి కస్టమర్‌గా లాగిన్ అవ్వండి",
    "offers.tab": "ఆఫర్లు",
    "offers.newTitle": "ఆఫర్ శీర్షిక",
    "offers.area": "లక్ష్య ప్రాంతం (ఐచ్ఛికం)",
    "dim.title": "వివరణాత్మక కొలతలు",
    "dim.label": "లేబుల్ (ఉదా. హాల్, బెడ్‌రూమ్, ప్లాట్)",
    "dim.value": "విలువ",
    "dim.unit": "యూనిట్",
    "dim.add": "కొలత జోడించండి",
    "dim.hint": "హాల్, బెడ్‌రూమ్, తూర్పు-పడమర, ఉత్తర-దక్షిణ వంటి కొలతలను ఏ యూనిట్‌లోనైనా జోడించండి.",
    "role.loginAs": "ఇలా లాగిన్ అవ్వండి",
    "role.registerAs": "ఇలా నమోదు అవ్వండి",
    "track.brokerUpdated": "మధ్యవర్తి అప్‌డేట్ చేశారు",
    "track.adminUpdated": "అడ్మిన్ అప్‌డేట్ చేశారు",
    "track.pendingApproval": "అడ్మిన్ ఆమోదం కోసం వేచి ఉంది",
    "track.needsApproval": "అడ్మిన్-నిర్వహణ · మార్పులకు ఆమోదం అవసరం",
    "enq.interest": "నా ఆసక్తి",
    "enq.buy": "కొనుగోలు",
    "enq.rent": "అద్దె",
    "enq.lease": "లీజు",
    "enq.sell": "అమ్మకం",
    "enq.assign": "మధ్యవర్తికి కేటాయించండి",
    "enq.assigned": "కేటాయించబడింది",
    "enq.due": "స్పందన గడువు",
    "enq.respond": "స్పందన సమర్పించండి",
    "enq.response": "మధ్యవర్తి స్పందన",
    "enq.responseDate": "అందుబాటు / స్పందన తేదీ",
    "enq.alert": "మధ్యవర్తి స్పందించారు — వివరాలు కింద చూడండి.",
    "admin.requests": "మార్పు అభ్యర్థనలు",
    "loading": "లోడ్ అవుతోంది...",
    "noResults": "ప్రాపర్టీలు కనబడలేదు. ఫిల్టర్లు మార్చి చూడండి.",
    "viewDetails": "వివరాలు చూడండి",
  },
};

const LanguageContext = createContext(null);

export function LanguageProvider({ children }) {
  const [lang, setLang] = useState(localStorage.getItem("mp_lang") || "en");
  const change = (l) => { setLang(l); localStorage.setItem("mp_lang", l); };
  const t = (key) => (translations[lang] && translations[lang][key]) || translations.en[key] || key;
  return (
    <LanguageContext.Provider value={{ lang, setLang: change, t }}>
      {children}
    </LanguageContext.Provider>
  );
}

export const useLang = () => useContext(LanguageContext);
